import Axios from 'axios'
import { authCredentials } from '../config/settings'

const endpointsRequest = () => Axios.get('https://auth-api.nesscs.com/server_locations.json', {
  auth: authCredentials,
})

export default endpointsRequest
